var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticClass:"flex primary-gradient-bg-light pa-5 align-self-stretch",attrs:{"outlined":""}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }